import { companyEmployees } from '@/modules/simulator/constants/company-size'
import { SimulatorDispatchContext } from '@/modules/simulator/contexts'
import { CompanyEmployees } from '@/modules/simulator/hooks'
import {
  WSegmentedButton,
  WSegmentedButtonGroup
} from '@alice-health/wonderland-react'
import { FunctionComponent, useContext } from 'react'
import { useDispatchPageEvent, usePreventDoubleClick } from '@/global/hooks'
import {
  ButtonType,
  EventName
} from '@/global/utils/analytics-events/types/common'
import { dispatchEvent } from '@/global/utils'
import { sendGTMEvent } from '@next/third-parties/google'
import { FormTemplate } from '@/modules/simulator/components/Forms'
import { strings } from './EmployeesNumber.helpers'

const EmployeesNumber: FunctionComponent = () => {
  useDispatchPageEvent({
    eventName: EventName.PAGE_VIEWED,
    pageTitle: strings.title
  })

  const { stepDispatch, simulationDispatch } = useContext(
    SimulatorDispatchContext
  )

  const onClick = usePreventDoubleClick(
    (companyEmployees: CompanyEmployees) => {
      dispatchAnalyticsEvents(companyEmployees)

      simulationDispatch({ type: 'SET_ANSWER', payload: { companyEmployees } })
      stepDispatch({ type: 'SET_STEP', payload: 2 })
    }
  )

  return (
    <FormTemplate
      title={strings.title}
      accordionDescription={strings.accordionDescription}
    >
      <WSegmentedButtonGroup direction='vertical'>
        {companyEmployees.map(({ value, label }, index) => (
          <WSegmentedButton
            className='max-w-[200px]'
            key={index}
            size='medium'
            value={value}
            onClick={() => onClick(value as CompanyEmployees)}
          >
            {label}
          </WSegmentedButton>
        ))}
      </WSegmentedButtonGroup>
    </FormTemplate>
  )
}

const dispatchAnalyticsEvents = (companyEmployees: CompanyEmployees) => {
  dispatchEvent({
    eventName: EventName.STEP_BUTTON_CLICKED,
    buttonType: ButtonType.NEW_PAGE,
    buttonName: companyEmployees,
    pageTitle: strings.title,
    totalEmployeesCompany: companyEmployees
  })

  sendGTMEvent({
    event: `${companyEmployees}_employees_answered`
  })
}

export { EmployeesNumber }
